import { isFeature } from 'Cloud/Application/FeaturesEs6';

/** CLOUDWEB-17806 Отображать ли кнопку добавления в облако для cloud аттачей */
export const shouldShowCloneButtonForCloudAttach = isFeature('show-clone-button-cloud-attach');
